export default [
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../pages/KurccProfilePage.vue'),
    meta: {
      auth: true
    }
  }
]
